var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',{staticStyle:{"background-color":"white"}},[_c('sds-layout',{staticClass:"fill-height",attrs:{"loading":_vm.loading}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }